import { render, staticRenderFns } from "./widget_portfolio_risk.vue?vue&type=template&id=fbbbeb0a&scoped=true&"
import script from "./widget_portfolio_risk.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_risk.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_risk.vue?vue&type=style&index=0&id=fbbbeb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbbeb0a",
  null
  
)

export default component.exports